import { render, staticRenderFns } from "./AppTableBody.vue?vue&type=template&id=2b37e97e"
import script from "./AppTableBody.vue?vue&type=script&lang=js"
export * from "./AppTableBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports